import { Row } from 'reactstrap';
import styled from 'styled-components';
import { BorderedCol, BottomMargin } from '../../../styledComponents/styledComponents';

export const WidthSensitiveRow = styled(Row)`
   /* display: flex; */
   @media (max-width: ${(props) => props.$breakPointWidthPx}px) {
      display: block;
   }
`;
WidthSensitiveRow.displayName = 'WidthSensitiveRow';

export const WidthSensitiveDisplayed = styled.div`
   /* display: block; */
   @media (max-width: ${(props) => props.$breakPointWidthPx}px) {
      display: none;
   }
`;
WidthSensitiveDisplayed.displayName = 'WidthSensitiveDisplayed';

export const WidthSensitiveBottomMargin = styled(BottomMargin)`
   @media (min-width: ${(props) => props.$breakPointWidthPx}px) {
      margin-bottom: ${(props) =>
         props.$wideDisplayBottomMarginPx !== undefined ? props.$wideDisplayBottomMarginPx : 0}px;
   }
`;
WidthSensitiveBottomMargin.displayName = 'WidthSensitiveBottomMargin';

export const WidthSensitiveBorderedCol = styled(BorderedCol)`
    ${(props) => props.$order !== undefined && `order: ${props.$order};`}
    @media (max-width: ${(props) => props.$breakPointWidthPx}px) {
        padding-right: 15px;
        padding-left: 15px;      
    }
`;
WidthSensitiveBorderedCol.displayName = 'WidthSensitiveBorderedCol';

export const PayloadGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
   gap: 20px;
   margin-top: 12px;
   padding: 16px;
   background-color: #f9fafb;
   border-radius: 6px;
`;
PayloadGrid.displayName = 'PayloadGrid';

export const PayloadField = styled.div`
   display: flex;
   flex-direction: column;
   gap: 4px;
`;
PayloadField.displayName = 'PayloadField';

export const PayloadLabel = styled.span`
   font-size: 12px;
   font-weight: 600;
   color: #999;
   text-transform: uppercase;
   letter-spacing: 0.5px;
`;
PayloadLabel.displayName = 'PayloadLabel';

export const PayloadValue = styled.span`
   font-size: 14px;
   color: #333;
   word-break: break-all;
`;
PayloadValue.displayName = 'PayloadValue';

export const CopyButtonContainer = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
`;
CopyButtonContainer.displayName = 'CopyButtonContainer';

export const CopyButton = styled.button`
   background: none;
   border: 1px solid #ddd;
   cursor: pointer;
   padding: 3px 8px;
   border-radius: 3px;
   display: flex;
   align-items: center;
   justify-content: center;
   color: #999;
   font-size: 11px;
   font-weight: 500;
   transition: all 0.2s ease;
   white-space: nowrap;
   height: fit-content;
   outline: none;

   &:hover {
      border-color: #999;
      color: #333;
      background-color: #fafafa;
   }

   &:active {
      transform: scale(0.95);
   }

   &:focus,
   &:focus-visible {
      outline: none;
   }
`;
CopyButton.displayName = 'CopyButton';

export const BlockRowGrid = styled.div`
   display: grid;
   grid-template-columns: 140px 1fr;
   column-gap: 8px;
   align-items: start;
   margin-bottom: 8px;
`;
BlockRowGrid.displayName = 'BlockRowGrid';

export const BlockRowControls = styled.div`
   display: flex;
   flex-direction: column;
   gap: 6px;
   margin-top: auto;
   margin-bottom: auto;
`;
BlockRowControls.displayName = 'BlockRowControls';

export const BlockRowStatusLine = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
`;
BlockRowStatusLine.displayName = 'BlockRowStatusLine';

export const BlockTagRow = styled.div`
   display: flex;
   align-items: center;
   gap: 6px;
   flex-wrap: wrap;
`;
BlockTagRow.displayName = 'BlockTagRow';

export const BlockPanel = styled.div`
   border: 1px solid #e5e7eb;
   border-radius: 6px;
   padding: 14px 16px;
   background-color: #f9fafb;
`;
BlockPanel.displayName = 'BlockPanel';

export const BlockPanelTitle = styled.div`
   font-size: 11px;
   font-weight: 600;
   color: #888;
   text-transform: uppercase;
   letter-spacing: 0.6px;
   margin-bottom: 10px;
`;
BlockPanelTitle.displayName = 'BlockPanelTitle';

export const BlockStatusDot = styled.span`
   display: inline-block;
   width: 8px;
   height: 8px;
   border-radius: 50%;
   flex-shrink: 0;
   background-color: ${(props) => (props.$blocked ? '#dc2626' : '#9ca3af')};
   margin-right: 6px;
`;
BlockStatusDot.displayName = 'BlockStatusDot';

export const BlockStatusText = styled.span`
   font-size: 13px;
   font-weight: 500;
   color: ${(props) => (props.$blocked ? '#dc2626' : '#6b7280')};
`;
BlockStatusText.displayName = 'BlockStatusText';

export const BlockTagInput = styled.input`
   padding: 5px 8px;
   font-size: 13px;
   border: 1px solid #d1d5db;
   border-radius: 4px;
   outline: none;
   background: #fff;
   &:focus {
      border-color: #9ca3af;
   }
   &:disabled {
      opacity: 0.6;
   }
`;
BlockTagInput.displayName = 'BlockTagInput';

export const BlockPanelContent = styled.div`
   display: flex;
   flex-direction: column;
   gap: 10px;
   margin-top: 12px;
   padding: 16px;
   background-color: #f9fafb;
   border-radius: 6px;
`;
BlockPanelContent.displayName = 'BlockPanelContent';

export const BlockStatusRow = styled.div`
   display: flex;
   align-items: center;
`;
BlockStatusRow.displayName = 'BlockStatusRow';

export const BlockCommentLabel = styled.div`
   font-size: 11px;
   color: #888;
   margin-top: 4px;
   margin-bottom: 4px;
`;
BlockCommentLabel.displayName = 'BlockCommentLabel';

export const BlockErrorText = styled.div`
   font-size: 12px;
   color: #dc2626;
`;
BlockErrorText.displayName = 'BlockErrorText';

export const BlockActionButton = styled.button`
   padding: 5px 12px;
   font-size: 12px;
   font-weight: 500;
   border-radius: 4px;
   border: none;
   white-space: nowrap;
   cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
   opacity: ${(props) => (props.disabled ? 0.6 : 1)};
   background-color: ${(props) => (props.$variant === 'block' ? 'rgb(255, 147, 63)' : 'rgb(100, 100, 100)')};
   color: #fff;
   transition: background-color 0.15s;
   &:hover:not(:disabled) {
      background-color: ${(props) => (props.$variant === 'block' ? 'rgb(230, 120, 40)' : 'rgb(75, 75, 75)')};
   }
   &:focus,
   &:focus-visible {
      outline: none;
   }
`;
BlockActionButton.displayName = 'BlockActionButton';
